export default "__VITE_ASSET__Dxg$UnOv__"